import { useMatch } from 'react-router-dom';

import useLoggedInUser from 'app/hooks/useLoggedInUser';
import { useUserDismissedState } from 'app/shared-components/modals';
import type { IntroPopUp } from 'app/shared-components/modals/types';
import { COMMAND_CENTRE_WELCOME_DISMISSED_KEY } from 'app/utils/seenStorageKeys';

/** Welcomes the user to the Command Centre the first time they open it. */
export default function useCommandCentreWelcomePopUp(): IntroPopUp {
  const user = useLoggedInUser();
  const onCommandCentre = useMatch('/command-centre') !== null;
  const { showOnboarding, dismiss } = useUserDismissedState(COMMAND_CENTRE_WELCOME_DISMISSED_KEY);

  if (!user || !onCommandCentre || !showOnboarding) return { status: 'hidden' };

  return { status: 'show', dismiss };
}
